import React from "react";
import PropTypes from "prop-types";
import { Color } from "../utils/variables";
import { Row } from "./Layout";

const Icons = {
  add: (
    <g>
      <path d="M11 20L11 4L13 4L13 20L11 20Z" />
      <path d="M20 13H4V11H20V13Z" />
    </g>
  ),
  addSmall: (
    <g transform="scale(0.9) translate(-1 -2)">
      <path d="M11 20L11 4L13 4L13 20L11 20Z" />
      <path d="M20 13H4V11H20V13Z" />
    </g>
  ),
  arrowDropDown: (
    <path d="M15.7929 10.5H8.2071C7.76165 10.5 7.53857 11.0386 7.85355 11.3536L11.6464 15.1464C11.8417 15.3417 12.1583 15.3417 12.3535 15.1464L16.1464 11.3536C16.4614 11.0386 16.2383 10.5 15.7929 10.5Z" />
  ),
  arrowLeft: (
    <path d="M5.41412 12.9998L9.70717 17.2929L8.29295 18.7071L1.58565 11.9998L8.29297 5.29287L9.70715 6.70713L5.41417 10.9998L21.0001 11L21.0001 13L5.41412 12.9998Z" />
  ),
  arrowLeftSmall: (
    <g>
      <path d="M5.82847 9.9999L10.1215 14.2929L8.70728 15.7071L3 9.99985L8.7073 4.29289L10.1215 5.70715L5.82847 9.9999Z" />
      <path d="M17.4144 11L4.41444 11L4.41444 9.00002L17.4144 9.00003L17.4144 11Z" />
    </g>
  ),
  arrowRight: (
    <path d="M17.1716 11.0001L12.8786 6.70709L14.2928 5.29287L21.0001 12.0002L14.2927 18.7071L12.8786 17.2929L17.1716 13.0001L1.58565 13L1.58567 11L17.1716 11.0001Z" />
  ),
  arrowRightSmall: (
    <g>
      <path d="M14.586 10.0001L10.293 5.70711L11.7072 4.29289L17.4144 10.0002L11.7071 15.7071L10.293 14.2929L14.586 10.0001Z" />
      <path d="M3 9L16 9L16 11L3 11L3 9Z" />
    </g>
  ),
  arrowDown: (
    <g transform="rotate(90, 12, 12)">
      <path d="M17.1716 11.0001L12.8786 6.70709L14.2928 5.29287L21.0001 12.0002L14.2927 18.7071L12.8786 17.2929L17.1716 13.0001L1.58565 13L1.58567 11L17.1716 11.0001Z" />
    </g>
  ),
  chevronRight: (
    <polygon points="7.30412639 5.71816427 8.69587361 4.28183573 16.4371028 11.7827896 8.69585403 19.2833532 7.30414597 17.8469868 13.563 11.782"></polygon>
  ),
  chevronDown: (
    <g transform="rotate(90, 12, 12)">
      <polygon points="7.30412639 5.71816427 8.69587361 4.28183573 16.4371028 11.7827896 8.69585403 19.2833532 7.30414597 17.8469868 13.563 11.782"></polygon>
    </g>
  ),
  chevronUp: (
    <g transform="rotate(-90, 12, 12)">
      <polygon points="7.30412639 5.71816427 8.69587361 4.28183573 16.4371028 11.7827896 8.69585403 19.2833532 7.30414597 17.8469868 13.563 11.782"></polygon>
    </g>
  ),
  calendar: (
    <g>
      <path
        fillRule="evenodd"
        d="M19 7H5L5 19H19V7ZM5 5C3.89543 5 3 5.89543 3 7V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V7C21 5.89543 20.1046 5 19 5H5Z"
      />
      <path d="M7 10H17V12H7V10Z" />
      <path d="M7 14H12V16H7V14Z" />
      <path d="M4 7C4 5.89543 4.89543 5 6 5H18C19.1046 5 20 5.89543 20 7V8H4V7Z" />
      <path d="M7 4C7 3.44772 7.44772 3 8 3H9C9.55228 3 10 3.44772 10 4V6C10 6.55228 9.55228 7 9 7H8C7.44772 7 7 6.55228 7 6V4Z" />
      <path d="M14 4C14 3.44772 14.4477 3 15 3H16C16.5523 3 17 3.44772 17 4V6C17 6.55228 16.5523 7 16 7H15C14.4477 7 14 6.55228 14 6V4Z" />
    </g>
  ),
  checkContainer: (
    <path
      fillRule="evenodd"
      d="M17 5H7C5.89543 5 5 5.89543 5 7V17C5 18.1046 5.89543 19 7 19H17C18.1046 19 19 18.1046 19 17V7C19 5.89543 18.1046 5 17 5ZM7 3C4.79086 3 3 4.79086 3 7V17C3 19.2091 4.79086 21 7 21H17C19.2091 21 21 19.2091 21 17V7C21 4.79086 19.2091 3 17 3H7Z"
    />
  ),
  checkFilled: (
    <g transform="translate(3 3)">
      <path d="M14,0 C16.209139,-4.05812251e-16 18,1.790861 18,4 L18,14 C18,16.209139 16.209139,18 14,18 L4,18 C1.790861,18 2.705415e-16,16.209139 0,14 L0,4 C-2.705415e-16,1.790861 1.790861,4.05812251e-16 4,0 L14,0 Z M13.4928959,4.79289057 L7.533,10.752 L4.90707799,8.12631443 L3.49282201,9.54048557 L7.53312613,13.5810321 L14.9071041,6.20710943 L13.4928959,4.79289057 Z"></path>
    </g>
  ),
  check: (
    <path d="M10.1665 13.9192L16.7928 7.29289L18.207 8.70711L10.1664 16.7477L5.7928 12.3738L7.20705 10.9597L10.1665 13.9192Z" />
  ),
  close: (
    <g>
      <path d="M19.2808 20.7808L3.5 5L4.91422 3.58578L20.695 19.3666L19.2808 20.7808Z" />
      <path d="M3.21918 19.2808L19 3.5L20.4142 4.91422L4.63339 20.695L3.21918 19.2808Z" />
    </g>
  ),
  closeLarge: (
    <g transform="scale(1.3 1.3)">
      <path d="M7.49994 9L0.219271 16.2807L1.63348 17.6949L8.91416 10.4142L16.2809 17.781L17.6951 16.3668L10.3284 9L17.4143 1.91406L16.0001 0.499849L8.91416 7.58579L1.91431 0.585938L0.500093 2.00015L7.49994 9Z" />
    </g>
  ),
  dots: (
    <g>
      <path d="M7 12C7 13.1046 6.10457 14 5 14C3.89543 14 3 13.1046 3 12C3 10.8954 3.89543 10 5 10C6.10457 10 7 10.8954 7 12Z" />
      <path d="M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z" />
      <path d="M21 12C21 13.1046 20.1046 14 19 14C17.8954 14 17 13.1046 17 12C17 10.8954 17.8954 10 19 10C20.1046 10 21 10.8954 21 12Z" />
    </g>
  ),
  down: (
    <g>
      <path d="M6.35791 7.55635L6.35791 19.5564L4.35791 19.5564L4.35791 7.55635L6.35791 7.55635Z" />
      <path d="M4.35791 17.5563L16.3579 17.5564L16.3579 19.5564L4.35791 19.5563L4.35791 17.5563Z" />
      <path d="M5.85791 19.5564L4.4437 18.1421L18.5858 4L20 5.41422L5.85791 19.5564Z" />
    </g>
  ),
  downSmall: (
    <g>
      <path d="M3.50001 13.3137L2.00001 13.3137L2 13.3137L2 11.3137L2.00001 11.3137L2.00002 5.31372L4.00002 5.31372L4.00002 9.98529L11.9853 2.00001L13.3995 3.41423L5.50002 11.3137L10 11.3137L10 13.3137L4.00001 13.3137L3.50001 13.3137Z" />
      <path d="M4.00002 5.31372L2.00002 5.31372L2.00001 11.3137L2 13.3137L10 13.3137L10 11.3137L5.50002 11.3137L13.3995 3.41423L11.9853 2.00001L4.00002 9.98529L4.00002 5.31372Z" />
    </g>
  ),
  info: (
    <path d="M11.3645 14.2918C11.4175 13.8727 11.5316 13.4483 11.7066 13.0186C11.8817 12.5889 12.0727 12.2016 12.2796 11.8568C12.4918 11.5119 12.6987 11.1777 12.9003 10.8541C13.1072 10.5305 13.2769 10.2095 13.4095 9.89125C13.5475 9.56764 13.6164 9.27056 13.6164 9C13.6111 8.53316 13.4626 8.16446 13.1708 7.8939C12.8843 7.62334 12.4838 7.48806 11.9692 7.48806C11.6403 7.48806 11.322 7.5305 11.0143 7.61538C10.7066 7.69496 10.4706 7.77454 10.3061 7.85411C10.1469 7.93369 9.96392 8.03714 9.75703 8.16446L9.2 6.8435C9.63501 6.56233 10.0859 6.35279 10.5528 6.21485C11.0196 6.07162 11.566 6 12.192 6C12.5687 6 12.9347 6.05836 13.2902 6.17507C13.6509 6.28647 13.9798 6.45093 14.2769 6.66843C14.5793 6.88064 14.8207 7.16446 15.0011 7.51989C15.1867 7.87533 15.2796 8.27586 15.2796 8.72149C15.2796 9.08223 15.2159 9.43767 15.0886 9.7878C14.9613 10.1379 14.7862 10.4828 14.5634 10.8223C14.3406 11.1618 14.1045 11.4934 13.8552 11.817C13.6111 12.1406 13.3353 12.5279 13.0276 12.9788C12.7252 13.4244 12.4652 13.8621 12.2477 14.2918H11.3645ZM11.7862 18C11.4414 18 11.1496 17.8806 10.9109 17.6419C10.6721 17.4032 10.5528 17.1194 10.5528 16.7905C10.5528 16.4562 10.6721 16.1671 10.9109 15.9231C11.1496 15.679 11.4414 15.557 11.7862 15.557C12.1257 15.557 12.4122 15.679 12.6456 15.9231C12.879 16.1671 12.9958 16.4562 12.9958 16.7905C12.9958 17.1194 12.879 17.4032 12.6456 17.6419C12.4122 17.8806 12.1257 18 11.7862 18Z" />
  ),
  search: (
    <g>
      <path
        fillRule="evenodd"
        d="M11 16C13.7614 16 16 13.7614 16 11C16 8.23858 13.7614 6 11 6C8.23858 6 6 8.23858 6 11C6 13.7614 8.23858 16 11 16ZM11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18Z"
      />
      <path d="M18.2929 20.7071L13.2929 15.7071L14.7071 14.2929L19.7071 19.2929L18.2929 20.7071Z" />
    </g>
  ),
  up: (
    <g>
      <path d="M18 16L18 4L20 4L20 16L18 16Z" />
      <path d="M20 6H8V4H20V6Z" />
      <path d="M18.5 4L19.9142 5.41421L5.77208 19.5563L4.35786 18.1421L18.5 4Z" />
    </g>
  ),
  upSmall: (
    <path d="M5.50002 5H9.89949L2 12.8995L3.41421 14.3137L11.5 6.2279V11H13.5V5V3H11.8995H11.5H5.50002V5Z" />
  ),
  twitter: (
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path>
  ),
  retweet: (
    <g>
      <path d="M23.77 15.67c-.292-.293-.767-.293-1.06 0l-2.22 2.22V7.65c0-2.068-1.683-3.75-3.75-3.75h-5.85c-.414 0-.75.336-.75.75s.336.75.75.75h5.85c1.24 0 2.25 1.01 2.25 2.25v10.24l-2.22-2.22c-.293-.293-.768-.293-1.06 0s-.294.768 0 1.06l3.5 3.5c.145.147.337.22.53.22s.383-.072.53-.22l3.5-3.5c.294-.292.294-.767 0-1.06zm-10.66 3.28H7.26c-1.24 0-2.25-1.01-2.25-2.25V6.46l2.22 2.22c.148.147.34.22.532.22s.384-.073.53-.22c.293-.293.293-.768 0-1.06l-3.5-3.5c-.293-.294-.768-.294-1.06 0l-3.5 3.5c-.294.292-.294.767 0 1.06s.767.293 1.06 0l2.22-2.22V16.7c0 2.068 1.683 3.75 3.75 3.75h5.85c.414 0 .75-.336.75-.75s-.337-.75-.75-.75z"></path>
    </g>
  ),
  reply: (
    <g>
      <path d="M14.046 2.242l-4.148-.01h-.002c-4.374 0-7.8 3.427-7.8 7.802 0 4.098 3.186 7.206 7.465 7.37v3.828c0 .108.044.286.12.403.142.225.384.347.632.347.138 0 .277-.038.402-.118.264-.168 6.473-4.14 8.088-5.506 1.902-1.61 3.04-3.97 3.043-6.312v-.017c-.006-4.367-3.43-7.787-7.8-7.788zm3.787 12.972c-1.134.96-4.862 3.405-6.772 4.643V16.67c0-.414-.335-.75-.75-.75h-.396c-3.66 0-6.318-2.476-6.318-5.886 0-3.534 2.768-6.302 6.3-6.302l4.147.01h.002c3.532 0 6.3 2.766 6.302 6.296-.003 1.91-.942 3.844-2.514 5.176z" />
    </g>
  ),
  download: (
    <g transform="translate(4 4)">
      <polygon
        id="Path"
        points="13.292892 7.2928944 14.707108 8.7071056 7.99979879 15.4144371 1.29287083 8.70708439 2.70712917 7.29291561 7.999 12.586"
      ></polygon>
      <polygon id="Path" points="9 0 9 14 7 14 7 0"></polygon>
      <polygon id="Path" points="16 14 16 16 0 16 0 14"></polygon>
    </g>
  ),
  share: (
    <g transform="translate(3 4)">
      <circle id="Oval" cx="2.5" cy="8" r="2.5"></circle>
      <circle id="Oval" cx="13.5" cy="2.5" r="2.5"></circle>
      <circle id="Oval" cx="13.5" cy="13.5" r="2.5"></circle>
      <polygon
        id="Path"
        points="13.0527864 1.60557281 13.9472136 3.39442719 2.9472136 8.89442719 2.0527864 7.10557281"
      ></polygon>
      <polygon
        id="Path"
        points="2.9472136 7.10557281 13.9472136 12.6055728 13.0527864 14.3944272 2.0527864 8.89442719"
      ></polygon>
    </g>
  ),
  edit: (
    <g transform="translate(2 2)">
      <path d="M5 11L14 2C15.5139 2.30278 16.6972 3.48612 17 5L8 14L5 11Z" />
      <path d="M7 15L4 12L3.9714 12.0286C3.66541 12.3346 3.46692 12.7316 3.40572 13.16L3 16L5.84003 15.5943C6.26842 15.5331 6.66541 15.3346 6.9714 15.0286L7 15Z" />
    </g>
  ),
  email: (
    <g transform="translate(0 -1)">
      <path
        d="M22 10.2803V18.052C22 18.868 21.6708 19.6507 21.0847 20.2277C20.4987 20.8047 19.7038 21.1289 18.875 21.1289H5.125C4.2962 21.1289 3.50134 20.8047 2.91529 20.2277C2.32924 19.6507 2 18.868 2 18.052V10.2803C3.69426 11.2619 8.17807 13.808 10.5233 15.1383C11.4403 15.6584 12.5597 15.6584 13.4767 15.1383C15.8219 13.808 20.3057 11.2619 22 10.2803ZM18.875 5.12891C19.6439 5.12879 20.3859 5.40781 20.959 5.91259C21.5321 6.41737 21.8961 7.11246 21.9813 7.86491L13.5036 12.775C12.5735 13.3136 11.4265 13.3136 10.4964 12.775L2.01875 7.86491C2.10395 7.11246 2.4679 6.41737 3.04099 5.91259C3.61408 5.40781 4.35607 5.12879 5.125 5.12891H18.875Z"
        fill="black"
      />
    </g>
  ),
  emailLarge: (
    <g transform="scale(0.38 0.38)">
      <path d="M0 46.4174V18.7138L20.0215 34.1315L0 46.4174ZM64 51.3709V51.7335C64 52.9117 63.0449 53.8669 61.8667 53.8669H2.13334C0.955128 53.8669 0 52.9117 0 51.7335V51.589L22.9313 37.5175L28.3928 41.9959C30.4901 43.7157 33.5099 43.7157 35.6072 41.9959L41.2209 37.3927L64 51.3709ZM64 46.1992V18.7138L44.1307 34.0067L64 46.1992ZM30.6473 38.2465C31.4338 38.8915 32.5662 38.8915 33.3527 38.2465L61.9422 14.9832C63.4916 13.7127 62.5932 11.2002 60.5895 11.2002H3.41053C1.40681 11.2002 0.508414 13.7127 2.05782 14.9832L30.6473 38.2465Z" />
    </g>
  ),
  analyticsLarge: (
    <g transform="scale(0.35 0.35) translate(-1 6)">
      <path
        d="M44.3333 35.3334L60.9999 7.55566"
        stroke="#88898C"
        stroke-width="4"
      />
      <path
        d="M8.22217 43.6664L24.8888 15.8887"
        stroke="#88898C"
        stroke-width="4"
      />
      <path
        d="M24.8888 15.8887L44.3332 35.3331"
        stroke="#88898C"
        stroke-width="4"
      />
      <path
        d="M61 13.1111C64.0683 13.1111 66.5556 10.6238 66.5556 7.55556C66.5556 4.48731 64.0683 2 61 2C57.9318 2 55.4445 4.48731 55.4445 7.55556C55.4445 10.6238 57.9318 13.1111 61 13.1111Z"
        fill="#88898C"
        stroke="#88898C"
        stroke-width="4"
      />
      <path
        d="M44.3333 40.8885C47.4015 40.8885 49.8888 38.4011 49.8888 35.3329C49.8888 32.2647 47.4015 29.7773 44.3333 29.7773C41.265 29.7773 38.7777 32.2647 38.7777 35.3329C38.7777 38.4011 41.265 40.8885 44.3333 40.8885Z"
        fill="#88898C"
        stroke="#88898C"
        stroke-width="4"
      />
      <path
        d="M24.8888 21.4441C27.9571 21.4441 30.4444 18.9568 30.4444 15.8886C30.4444 12.8203 27.9571 10.333 24.8888 10.333C21.8206 10.333 19.3333 12.8203 19.3333 15.8886C19.3333 18.9568 21.8206 21.4441 24.8888 21.4441Z"
        fill="#88898C"
        stroke="#88898C"
        stroke-width="4"
      />
      <path
        d="M8.22218 49.2224C11.2904 49.2224 13.7777 46.7351 13.7777 43.6669C13.7777 40.5986 11.2904 38.1113 8.22218 38.1113C5.15393 38.1113 2.66663 40.5986 2.66663 43.6669C2.66663 46.7351 5.15393 49.2224 8.22218 49.2224Z"
        fill="#88898C"
        stroke="#88898C"
        stroke-width="4"
      />
    </g>
  ),
  drawer: <path d="M20 6H4V4H20V6ZM20 13H4V11H20V13ZM20 20H4V18H20V20Z" />,
  warning: (
    <path d="M10.5328875,0.962728421 L0.486785909,16.8931596 C-0.598397993,18.61411 0.192435598,20 2.24636736,20 L21.7554589,20 C23.8084592,20 24.5964983,18.6095451 23.5150404,16.8931596 L13.4689387,0.962728421 C12.6604069,-0.319082882 11.3442139,-0.322734766 10.533819,0.962728421 L10.5328875,0.962728421 Z M11.3982402,1.30509255 C11.7214666,0.792915812 12.2477575,0.794741754 12.5700525,1.30509255 L22.8210816,17.5404561 C23.3604133,18.394997 22.9570789,19.087942 21.9436196,19.087942 L2.02467314,19.087942 C1.00096747,19.087942 0.605084927,18.3995618 1.14721113,17.5404561 L11.3982402,1.30509255 Z M12.0009131,6.30543479 C11.4867316,6.30543479 11.0694248,6.71901066 11.0694248,7.21566689 L11.0694248,12.6989708 C11.0694248,13.2020178 11.4830056,13.6092029 12.0009131,13.6092029 C12.5150947,13.6092029 12.9324015,13.195627 12.9324015,12.6989708 L12.9324015,7.21566689 C12.9324015,6.71261987 12.5188206,6.30543479 12.0009131,6.30543479 L12.0009131,6.30543479 Z M12.0009131,17.261087 C12.5150947,17.261087 12.9324015,16.8520759 12.9324015,16.3481159 C12.9324015,15.8441559 12.5150947,15.4351449 12.0009131,15.4351449 C11.4867316,15.4351449 11.0694248,15.8441559 11.0694248,16.3481159 C11.0694248,16.8520759 11.4867316,17.261087 12.0009131,17.261087 L12.0009131,17.261087 Z" />
  ),
  positive: (
    <path d="M10,0 C15.52285,0 20,4.47715 20,10 C20,15.52285 15.52285,20 10,20 C4.47715,20 0,15.52285 0,10 C0,4.47715 4.47715,0 10,0 Z M14.50005,12 L5.50005,12 C5.50005,14.4853 7.51475,16.5 10.00005,16.5 C12.48535,16.5 14.50005,14.4853 14.50005,12 Z M14.99995,6 L11.99995,6 L11.99995,9 L14.99995,9 L14.99995,6 Z M8,6 L5,6 L5,9 L8,9 L8,6 Z"></path>
  ),
  negative: (
    <path d="M10,0 C15.52285,0 20,4.47715 20,10 C20,15.52285 15.52285,20 10,20 C4.47715,20 0,15.52285 0,10 C0,4.47715 4.47715,0 10,0 Z M9.99995,10.5 C7.5147,10.5 5.49995,12.5147 5.49995,15 L14.49995,15 C14.49995,12.5147 12.48525,10.5 9.99995,10.5 Z M14.99995,6 L11.99995,6 L11.99995,9 L14.99995,9 L14.99995,6 Z M8,6 L5,6 L5,9 L8,9 L8,6 Z"></path>
  ),
  neutral: (
    <path d="M10,0 C15.5228333,0 20,4.47715 20,10 C20,15.5228333 15.5228333,20 10,20 C4.47715,20 0,15.5228333 0,10 C0,4.47715 4.47715,0 10,0 Z M12.5,12.5 L7.5,12.5 L7.5,15 L12.5,15 L12.5,12.5 Z M15,5.99975833 L12,5.99975833 L12,8.99975833 L15,8.99975833 L15,5.99975833 Z M8,5.99975833 L5,5.99975833 L5,8.99975833 L8,8.99975833 L8,5.99975833 Z"></path>
  ),
  link: (
    <path d="M7.43461197,9.31986212 L3.59561197,13.1588621 C2.34961197,14.4048621 2.34261197,16.4858621 3.66261197,17.8058621 C4.98261197,19.1258621 7.06261197,19.1198621 8.30961197,17.8728621 L12.148612,14.0338621 L14.034612,15.9198621 L10.195612,19.7588621 C7.87161197,22.0828621 4.10261197,22.0158621 1.77761197,19.6918621 C-0.547388034,17.3678621 -0.614388034,13.5978621 1.71061197,11.2738621 L5.54961197,7.43486212 L7.43561197,9.32086212 L7.43461197,9.31986212 Z M17.805612,3.66286212 C16.485612,2.34286212 14.405612,2.34886212 13.158612,3.59586212 L9.31961197,7.43486212 L7.43361197,5.54886212 L11.272612,1.70986212 C13.596612,-0.614137878 17.365612,-0.547137878 19.690612,1.77686212 C22.015612,4.10086212 22.082612,7.87086212 19.757612,10.1948621 L15.918612,14.0338621 L14.032612,12.1478621 L17.871612,8.30886212 C19.117612,7.06286212 19.124612,4.98286212 17.804612,3.66186212 L17.805612,3.66286212 Z M13.562612,6.01986212 L15.448612,7.90586212 L7.90661197,15.4478621 L6.02061197,13.5618621 L13.562612,6.01986212 Z"></path>
  ),
  cursor: (
    <g transform="scale(0.8) translate(8 1)">
      <path d="M13 2c-3.313 0-5 1.172-5 3.5v6.5h2v2h-2v8.5c0 2.328 1.687 3.5 5 3.5h1v2h-1c-2.812 0-4.875-0.812-6-2.281-1.125 1.469-3.187 2.281-6 2.281h-1v-2h1c3.313 0 5-1.172 5-3.5v-8.5h-2v-2h2v-6.5c0-2.328-1.687-3.5-5-3.5h-1v-2h1c2.812 0 4.875 0.812 6 2.281 1.125-1.469 3.187-2.281 6-2.281h1v2h-1z"></path>
    </g>
  ),
  reload: (
    <path d="M12 18v-3l3.984 3.984-3.984 4.031v-3q-3.281 0-5.648-2.367t-2.367-5.648q0-2.344 1.266-4.266l1.453 1.453q-0.703 1.266-0.703 2.813 0 2.484 1.758 4.242t4.242 1.758zM12 3.984q3.281 0 5.648 2.367t2.367 5.648q0 2.344-1.266 4.266l-1.453-1.453q0.703-1.266 0.703-2.813 0-2.484-1.758-4.242t-4.242-1.758v3l-3.984-3.984 3.984-4.031v3z"></path>
  ),
  send: (
    <path d="M4.00056 4.43701L20.3863 12L4 19.5629V17.2449L6.86907 11.9858C6.83413 11.918 6.79595 11.844 6.7549 11.7647C6.53657 11.3425 6.23747 10.7679 5.91401 10.1573C5.25393 8.91147 4.53157 7.59134 4.1723 7.0603L4.00056 6.80644V4.43701ZM8.8913 11.5457L9.131 12.0157L6.96093 15.9935L15.6137 11.9999L7.05247 8.04841C7.26556 8.44005 7.4801 8.84128 7.68129 9.22102C8.00876 9.83909 8.31106 10.4199 8.5314 10.8459C8.64161 11.0591 8.73143 11.2337 8.79376 11.3552L8.8913 11.5457Z" />
  ),
  chat: (
    <path d="M6 18.4726C4.8059 18.7314 4 19 4 19V10C4 7.23858 6.23858 5 9 5H15C17.7614 5 20 7.23858 20 10V13C20 15.7614 17.7614 18 15 18H10C8.55489 18 7.10979 18.232 6 18.4726ZM6 16.4298C7.13054 16.2042 8.54906 16 10 16H15C16.6569 16 18 14.6569 18 13V10C18 8.34315 16.6569 7 15 7H9C7.34315 7 6 8.34315 6 10V16.4298Z" />
  ),
  copy: (
    <path d="M11.1615 1H16.8385C17.3657 0.999983 17.8205 0.999967 18.195 1.03057C18.5904 1.06287 18.9836 1.13419 19.362 1.32698C19.9265 1.6146 20.3854 2.07354 20.673 2.63803C20.8658 3.01641 20.9371 3.40963 20.9694 3.80497C21 4.17954 21 4.6343 21 5.16144V14.8386C21 15.3657 21 15.8205 20.9694 16.195C20.9371 16.5904 20.8658 16.9836 20.673 17.362C20.3854 17.9265 19.9265 18.3854 19.362 18.673C18.9836 18.8658 18.5904 18.9371 18.195 18.9694C17.8592 18.9969 17.459 18.9997 17 19C16.9997 19.459 16.9969 19.8592 16.9694 20.195C16.9371 20.5904 16.8658 20.9836 16.673 21.362C16.3854 21.9265 15.9265 22.3854 15.362 22.673C14.9836 22.8658 14.5904 22.9371 14.195 22.9694C13.8205 23 13.3657 23 12.8386 23H7.16144C6.6343 23 6.17954 23 5.80497 22.9694C5.40963 22.9371 5.01641 22.8658 4.63803 22.673C4.07355 22.3854 3.6146 21.9265 3.32698 21.362C3.13419 20.9836 3.06287 20.5904 3.03057 20.195C2.99997 19.8205 2.99998 19.3657 3 18.8385V9.16146C2.99998 8.63431 2.99997 8.17955 3.03057 7.80497C3.06287 7.40963 3.13419 7.01641 3.32698 6.63803C3.6146 6.07354 4.07354 5.6146 4.63803 5.32698C5.01641 5.13419 5.40963 5.06287 5.80497 5.03057C6.14076 5.00314 6.54098 5.00031 7.00003 5.00003C7.00031 4.54098 7.00314 4.14076 7.03057 3.80497C7.06287 3.40963 7.13419 3.01641 7.32698 2.63803C7.6146 2.07354 8.07354 1.6146 8.63803 1.32698C9.01641 1.13419 9.40963 1.06287 9.80497 1.03057C10.1795 0.999967 10.6343 0.999983 11.1615 1ZM9.00007 5L12.8385 5C13.3657 4.99998 13.8205 4.99997 14.195 5.03057C14.5904 5.06287 14.9836 5.13419 15.362 5.32698C15.9265 5.6146 16.3854 6.07354 16.673 6.63803C16.8658 7.01641 16.9371 7.40963 16.9694 7.80497C17 8.17955 17 8.63432 17 9.16148V16.9999C17.4651 16.9995 17.783 16.9964 18.0322 16.9761C18.3038 16.9539 18.4045 16.9162 18.454 16.891C18.6422 16.7951 18.7951 16.6422 18.891 16.454C18.9162 16.4045 18.9539 16.3038 18.9761 16.0322C18.9992 15.7488 19 15.3766 19 14.8V5.2C19 4.62345 18.9992 4.25117 18.9761 3.96784C18.9539 3.69617 18.9162 3.59546 18.891 3.54601C18.7951 3.35785 18.6422 3.20487 18.454 3.109C18.4045 3.0838 18.3038 3.04612 18.0322 3.02393C17.7488 3.00078 17.3766 3 16.8 3H11.2C10.6234 3 10.2512 3.00078 9.96784 3.02393C9.69617 3.04612 9.59546 3.0838 9.54601 3.109C9.35785 3.20487 9.20487 3.35785 9.109 3.54601C9.0838 3.59546 9.04612 3.69617 9.02393 3.96784C9.00357 4.21698 9.00052 4.5349 9.00007 5ZM5.96784 7.02393C5.69617 7.04612 5.59546 7.0838 5.54601 7.109C5.35785 7.20487 5.20487 7.35785 5.109 7.54601C5.0838 7.59546 5.04612 7.69617 5.02393 7.96784C5.00078 8.25117 5 8.62345 5 9.2V18.8C5 19.3766 5.00078 19.7488 5.02393 20.0322C5.04612 20.3038 5.0838 20.4045 5.109 20.454C5.20487 20.6422 5.35785 20.7951 5.54601 20.891C5.59546 20.9162 5.69617 20.9539 5.96784 20.9761C6.25117 20.9992 6.62345 21 7.2 21H12.8C13.3766 21 13.7488 20.9992 14.0322 20.9761C14.3038 20.9539 14.4045 20.9162 14.454 20.891C14.6422 20.7951 14.7951 20.6422 14.891 20.454C14.9162 20.4045 14.9539 20.3038 14.9761 20.0322C14.9992 19.7488 15 19.3766 15 18.8V9.2C15 8.62345 14.9992 8.25117 14.9761 7.96784C14.9539 7.69617 14.9162 7.59546 14.891 7.54601C14.7951 7.35785 14.6422 7.20487 14.454 7.109C14.4045 7.0838 14.3038 7.04612 14.0322 7.02393C13.7488 7.00078 13.3766 7 12.8 7H7.2C6.62345 7 6.25118 7.00078 5.96784 7.02393Z"></path>
  ),
  yt: (
    <g transform="scale(0.7) translate(1 1)">
      <path d="M12.932 20.459v-8.917l7.839 4.459zM30.368 8.735c-0.354-1.301-1.354-2.307-2.625-2.663l-0.027-0.006c-3.193-0.406-6.886-0.638-10.634-0.638-0.381 0-0.761 0.002-1.14 0.007l0.058-0.001c-0.322-0.004-0.701-0.007-1.082-0.007-3.748 0-7.443 0.232-11.070 0.681l0.434-0.044c-1.297 0.363-2.297 1.368-2.644 2.643l-0.006 0.026c-0.4 2.109-0.628 4.536-0.628 7.016 0 0.088 0 0.176 0.001 0.263l-0-0.014c-0 0.074-0.001 0.162-0.001 0.25 0 2.48 0.229 4.906 0.666 7.259l-0.038-0.244c0.354 1.301 1.354 2.307 2.625 2.663l0.027 0.006c3.193 0.406 6.886 0.638 10.634 0.638 0.38 0 0.76-0.002 1.14-0.007l-0.058 0.001c0.322 0.004 0.702 0.007 1.082 0.007 3.749 0 7.443-0.232 11.070-0.681l-0.434 0.044c1.298-0.362 2.298-1.368 2.646-2.643l0.006-0.026c0.399-2.109 0.627-4.536 0.627-7.015 0-0.088-0-0.176-0.001-0.263l0 0.013c0-0.074 0.001-0.162 0.001-0.25 0-2.48-0.229-4.906-0.666-7.259l0.038 0.244z"></path>
    </g>
  ),
  play: (
    <path d="M12,0 C18.6274,0 24,5.37258 24,12 C24,18.6274 18.6274,24 12,24 C5.37258,24 0,18.6274 0,12 C0,5.37258 5.37258,0 12,0 Z M9,7 L9,17 L17,12 L9,7 Z"></path>
  ),
  linkedin: (
    <path d="M20.9479 2.1543H3.05207C2.19566 2.1543 1.5 2.82914 1.5 3.65823V21.6504C1.5 22.4822 2.19566 23.1543 3.05207 23.1543H20.9479C21.8043 23.1543 22.5 22.4795 22.5 21.6504V3.65823C22.5 2.82639 21.8043 2.1543 20.9479 2.1543ZM7.86624 19.736H4.69559V10.2524H7.86624V19.736ZM6.28092 8.95781H6.26152C5.19724 8.95781 4.5099 8.23063 4.5099 7.31891C4.5099 6.40718 5.21941 5.68001 6.30309 5.68001C7.38676 5.68001 8.05471 6.3879 8.07688 7.31891C8.07688 8.22788 7.38953 8.95781 6.28369 8.95781H6.28092ZM19.3044 19.736H16.1338V14.6623C16.1338 13.387 15.6737 12.5166 14.5263 12.5166C13.6505 12.5166 13.1294 13.1033 12.8994 13.6707C12.8162 13.8745 12.794 14.1555 12.794 14.4392V19.736H9.6234C9.6234 19.736 9.66497 11.1421 9.6234 10.2524H12.794V11.5966C13.2153 10.9493 13.9692 10.0321 15.6515 10.0321C17.7385 10.0321 19.3044 11.3872 19.3044 14.3015V19.7388V19.736Z" />
  ),
  facebook: (
    <path d="M22 11C22 4.95 17.05 0 11 0C4.95 0 0 4.95 0 11C0 16.5 3.9875 21.0375 9.2125 21.8625V14.1625H6.4625V11H9.2125V8.525C9.2125 5.775 10.8625 4.2625 13.3375 4.2625C14.575 4.2625 15.8125 4.5375 15.8125 4.5375V7.2875H14.4375C13.0625 7.2875 12.65 8.1125 12.65 8.9375V11H15.675L15.125 14.1625H12.5125V22C18.0125 21.175 22 16.5 22 11Z" />
  ),
  noImage: (
    <g transform="scale(0.8 0.8)">
      <path d="M30,3.4141,28.5859,2,2,28.5859,3.4141,30l2-2H26a2.0027,2.0027,0,0,0,2-2V5.4141ZM26,26H7.4141l7.7929-7.793,2.3788,2.3787a2,2,0,0,0,2.8284,0L22,19l4,3.9973Zm0-5.8318-2.5858-2.5859a2,2,0,0,0-2.8284,0L19,19.1682l-2.377-2.3771L26,7.4141Z" />
      <path d="M6,22V19l5-4.9966,1.3733,1.3733,1.4159-1.416-1.375-1.375a2,2,0,0,0-2.8284,0L6,16.1716V6H22V4H6A2.002,2.002,0,0,0,4,6V22Z" />
    </g>
  ),
  quote: (
    <g transform="scale(0.8 0.8) translate(0 4)">
      <path d="M30.2246 0L24.9512 24.0723H14.6973L21.9238 0H30.2246ZM15.5762 0L10.6934 24.0723H0L7.8125 0H15.5762Z" />
    </g>
  ),
  saveOff: (
    <path
      fill-rule="evenodd"
      d="M7.52625 3C6.0438 3 4.84204 4.20176 4.84204 5.68421V20H6.63151V19.9687L12 14.9607L17.3684 19.9683V20H19.1578V5.68421C19.1578 4.20176 17.9561 3 16.4736 3H7.52625ZM17.3684 17.5212V5.68421C17.3684 5.19006 16.9678 4.78947 16.4736 4.78947H7.52625C7.0321 4.78947 6.63151 5.19006 6.63151 5.68421V17.5215L12 12.5136L17.3684 17.5212Z"
    />
  ),
  saveOn: (
    <path d="M4.84216 5.68421C4.84216 4.20176 6.04393 3 7.52637 3H16.4737C17.9562 3 19.158 4.20176 19.158 5.68421V20H18.2633H17.3685V19.9683L12.0002 14.9607L6.63164 19.9687V20H5.73696H4.84216V5.68421Z" />
  ),
};

export const Icon = ({ name, size, small, color, fade, fill, className }) => (
  // <Row bkg="red">
  <svg
    className={className}
    width={size || (small ? "20" : "24")}
    height={size || (small ? "20" : "24")}
    viewBox={`0 0 ${small ? "20" : "24"} ${small ? "20" : "24"}`}
    fill={fill ? fill : color ? Color(color, fade || "0") : "#000000"}
    xmlns="http://www.w3.org/2000/svg"
  >
    {Icons[small ? name + "Small" : name]}
  </svg>
  // </Row>
);

Icon.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.string,
  small: PropTypes.bool,
  color: PropTypes.string,
  fade: PropTypes.string,
  fill: PropTypes.string,
};
